import { supabase } from '../config/supabaseConfig.ts';

// Uso del asistente de smooth por proyecto (script 50). Todo pasa por RPC: las tablas no se leen directo.
const call = async (name, args) => {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw error;
  return data;
};

export const assistantUsageService = {
  overview: () => call('assistant_admin_overview', {}),
  series: (projectId, from, to) => call('assistant_admin_series', { p_project: projectId, p_from: from, p_to: to }),
  // Plan con el que nacen los clientes nuevos (script 51) y corte general: true = cortar al llegar al límite, false = solo avisar
  defaults: (planId, enforce = null) => call('assistant_admin_defaults', { p_plan: planId || null, p_enforce: enforce }),
  enforceAll: (enforce) => call('assistant_admin_enforce_all', { p_enforce: enforce }),
  settings: (patch = {}) => call('assistant_admin_settings', {
    p_voice_usd_per_minute: patch.voiceUsdPerMinute ?? null, p_warn_pct: patch.warnPct ?? null, p_voice_max_seconds: patch.voiceMaxSeconds ?? null,
  }),
  // Campos vacíos = sin tope propio (se usa el del plan)
  setPlan: (projectId, { planId, textTurns, voiceMinutes, costCap, blocked, reason, enforce }) => call('assistant_admin_set', {
    p_project: projectId, p_plan: planId || null, p_text_turns: textTurns ?? null, p_voice_minutes: voiceMinutes ?? null, p_cost_cap: costCap ?? null,
    p_blocked: !!blocked, p_reason: reason || null, p_enforce: enforce !== false,
  }),
  resolve: (requestId, approve, { extraTurns = 0, extraMinutes = 0, extraUsd = 0, note = '' } = {}) => call('assistant_admin_resolve', {
    p_request: requestId, p_approve: approve, p_extra_turns: extraTurns, p_extra_minutes: extraMinutes, p_extra_usd: extraUsd, p_note: note || null,
  }),
};
